import policyApi from "~/api/policy";
import customerApi from "~/api/customer";

const getInitialPolicyShowPageData = ({ state, commit, dispatch }) => {
  if (!state.policyId) return;
  commit("SET_PAGE_LOADED", false);
  policyApi.getInitialPolicyShowPageData(state.policyId).then((response) => {
    commit("SET_POLICY", response.data.policy.data);
    dispatch("getInstance", undefined, { root: true });
    commit("SET_RENDERABLE_TABS", response.data.renderableTabs);
    commit("SET_ATTACHABLES_WIDGET", response.data.attachables);
    commit("SET_PAGE_LOADED", true);
  });
};

const deletePolicy = ({ state }) => {
  if (!state.policyId) return;
  policyApi.deletePolicy(state.policy.customer_id, state.policy.id);
};

const getCustomerById = ({ commit }, id) => {
  customerApi.find(id).then((response) => {
    commit("SET_CUSTOMER", response.data);
  });
};
export default {
  getInitialPolicyShowPageData,
  deletePolicy,
  getCustomerById,
};
